<template>
  <div :class="$style.maincontainer">
    <h1 :class="$style.header">Congrats, you've begun.</h1>
    <div :class="$style.writingCollection">
      <!-- <h4>As a <strong :class="$style.strong">CREATOR,</strong>  all success originates in your mind with a plan.</h4> -->
      <h4>Welcome to the most powerful YouTube creative workflow community. Let's plan some videos.</h4>
      <router-link :to="'/dashboard'" class="btn btn-outline-sales"><strong>START</strong></router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WelcomeCreator',
}
</script>
<style lang="scss" module>
@import "@/components/cleanui/system/Auth/style.module.scss";
</style>
